import Header from '../components/Header';
import MobileStickyCTA from '../components/MobileStickyCTA';
import Hero from '../components/Hero';
import WhySection from '../components/WhySection';
import Features from '../components/Features';
import UseCases from '../components/UseCases';
import HowItWorks from '../components/HowItWorks';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SchemaMarkup from '../components/SchemaMarkup';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { i18n } = useTranslation();

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>Smart Coolers for Your Location | Tap'nGrab Montreal</title>
        <meta 
          name="description" 
          content="Zero-cost AI-powered smart coolers for offices, gyms, residential buildings in Montreal & South Shore. Contactless, fully managed amenity." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Tap'nGrab - Smart Coolers Montreal" />
        <meta property="og:description" content="Premium smart cooler amenity with zero cost and zero hassle for property owners." />
        <meta property="og:url" content="https://tapngrab.ca/" />
        <meta property="og:image" content="https://tapngrab.ca/images/smart-store.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content={i18n.language === 'fr' ? 'fr_CA' : 'en_CA'} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tap'nGrab - Smart Coolers Montreal" />
        <meta name="twitter:description" content="Premium smart cooler amenity with zero cost and zero hassle for property owners." />
        <meta name="twitter:image" content="https://tapngrab.ca/images/smart-store.png" />
        <link rel="canonical" href="https://tapngrab.ca/" />
        <link rel="alternate" hreflang="fr" href="https://tapngrab.ca/fr/" />
        <link rel="alternate" hreflang="en" href="https://tapngrab.ca/" />
      </Helmet>

      <SchemaMarkup 
        pageType="home"
        language={i18n.language}
        includeOrganization={true}
        includeLocalBusiness={true}
        includeProduct={true}
      />

      <div className="text-slate-800 bg-white">
        <MobileStickyCTA />
        <Header />
        <Hero />
        <WhySection />
        <Features />
        <UseCases />
        <HowItWorks />
        <CTASection />
        <Footer />
      </div>
    </>
  );
};

export default Home;
